module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: ["dof-panel"]
  }, [_c('div', {
    class: ['dof-panel-container', !_vm.hasBottomBar && 'container-bottom-padding']
  }, _vm._l((_vm.matrixData), function(line, index) {
    return _c('div', {
      key: index,
      staticClass: ["dashboard"]
    }, _vm._l((line), function(item, i) {
      return _c('div', {
        key: i,
        class: ['cell', !_vm.hasBottomBar && 'cell-no-Btn-Bar'],
        style: [
          _vm.adaptBorderFn(index, _vm.matrixData.length - 1, i, line.length - 1),
          _vm.adaptPaddingFn(index, _vm.matrixData.length - 1, i, line.length - 1)
        ]
      }, [_c('div', {
        staticClass: ["title"]
      }, [_c('text', {
        staticClass: ["title-text"]
      }, [_vm._v(_vm._s(item.title))])]), _c('div', {
        staticClass: ["value"]
      }, [_c('text', {
        staticClass: ["value-text"]
      }, [_vm._v(_vm._s(item.value))]), _c('text', {
        staticClass: ["unit-text"]
      }, [_vm._v(_vm._s(item.unit))])])])
    }))
  })), (_vm.hasBottomBar) ? _c('div', {
    staticClass: ["btn"],
    on: {
      "click": _vm.onClicked
    }
  }, [_c('text', {
    staticClass: ["btn-text"],
    style: _vm.mrTextStyle
  }, [_vm._v(_vm._s(_vm.btnText))])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true


//////////////////
// WEBPACK FOOTER
// ./~/weex-vue-loader/lib/template-compiler.js?id=data-v-5def8261!./~/weex-vue-loader/lib/selector.js?type=template&index=0!./packages/dof-panel/index.vue
// module id = 619
// module chunks = 0 1